import React from 'react';
import styled from 'styled-components';

type Props = {
    loading?: boolean; 
};

const Loading = (props: Props) => {
    const { loading } = props;
    return loading ?  (
        <LoadingWithStyled>
            読み込み中です
        </LoadingWithStyled>
    ) :  (
        <LoadedWithStyled className='loading--loaded'>
            読み込み中です
        </LoadedWithStyled>
    );
};
const LoadingWithStyled = styled.span`
    color: #888;
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    height: 32px;
    text-align: left;
    margin-top: 18px;
    position: relative;
    top: 3px;
`
const LoadedWithStyled = styled.span`
    color: #888;
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    height: 32px;
    text-align: right;
    margin-top: 18px;
    position: absolute;
    white-space: nowrap;
    right: 10px;
    top: 3px;
    width: 100%;
    z-index: 100;
`
export default Loading;